import { useEffect, useState, useCallback } from 'react';
import { useAuth } from './AuthContext';
import styles from './AdminUsers.module.css';
import LoadMoreButton from './components/LoadMoreButton';

export default function AdminUsers() {
  const { user: me } = useAuth();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [error, setError] = useState(null);
  const [visibleCount, setVisibleCount] = useState(50);

  const load = useCallback(async () => {
    const res = await fetch('/api/admin/users', { credentials: 'include' });
    if (!res.ok) {
      setError('사용자 목록을 불러오지 못했습니다.');
      return;
    }
    const data = await res.json();
    setUsers(data.data || []);
  }, []);

  useEffect(() => { load(); }, [load]);

  async function update(id, patch) {
    const res = await fetch(`/api/admin/users/${id}`, {
      method: 'PATCH',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(patch),
    });
    if (!res.ok) {
      const d = await res.json().catch(() => ({}));
      alert('변경 실패: ' + (d.error || res.status));
      return;
    }
    await load();
  }

  const filtered = users.filter(u =>
    !search || u.email.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className={styles.wrap}>
      <input
        className={styles.search}
        placeholder="이메일 검색"
        value={search}
        onChange={e => { setSearch(e.target.value); setVisibleCount(50); }}
      />
      {error && <p style={{ color: '#c00' }}>{error}</p>}
      <table className={styles.table}>
        <thead>
          <tr>
            <th>이메일</th>
            <th>이름</th>
            <th>이메일 인증</th>
            <th>Access Level</th>
            <th>Admin</th>
            <th>마지막 로그인</th>
            <th>가입일</th>
          </tr>
        </thead>
        <tbody>
          {filtered.slice(0, visibleCount).map(u => (
            <tr key={u.id}>
              <td>{u.email}</td>
              <td>{u.name || '-'}</td>
              <td>
                <span className={u.email_verified ? `${styles.badge} ${styles.badgeOn}` : `${styles.badge} ${styles.badgeOff}`}>
                  {u.email_verified ? '인증됨' : '미인증'}
                </span>
              </td>
              <td>
                <select
                  className={styles.select}
                  value={u.access_level}
                  onChange={e => update(u.id, { access_level: e.target.value })}
                >
                  <option value="NONE">NONE</option>
                  <option value="VIEWER">VIEWER</option>
                </select>
              </td>
              <td>
                <button
                  className={`${styles.toggle} ${u.is_admin ? styles.toggleOn : ''}`}
                  onClick={() => update(u.id, { is_admin: !u.is_admin })}
                  disabled={u.id === me?.id && u.is_admin}
                  title={u.id === me?.id && u.is_admin ? '본인 admin은 해제할 수 없음' : ''}
                >
                  {u.is_admin ? 'ADMIN' : 'OFF'}
                </button>
              </td>
              <td>{u.last_login_at ? new Date(u.last_login_at).toLocaleString() : '-'}</td>
              <td>{new Date(u.created).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <LoadMoreButton hasMore={filtered.length > visibleCount} onClick={() => setVisibleCount(c => c + 50)} shown={Math.min(visibleCount, filtered.length)} total={filtered.length} />
    </div>
  );
}
